<template>
    <v-menu :close-on-content-click="true" ref="entityMenu">
        <template v-slot:activator="{ props }">
            <v-btn
                class="align-self-center mr-4"
                style="box-shadow: none"
                variant="text"
                v-bind="props"
            >
                {{ title }}
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                :key="`${thingSchema.id}`"
                v-for="thingSchema in thingSchemas"
                @click="selectThingSchema(thingSchema)"
            >
                <v-row>
                    <v-col cols="8">{{ `${thingSchema.displayName}` }}</v-col>
                    <v-col cols="4">
                        <v-icon
                            :id="`entity-${thingSchema.id}`"
                            end
                            @click.stop="downloadCustomEntitySetupExcel(thingSchema)"
                            class="text-right"
                            >$arrow-down-bold-circle</v-icon
                        >
                        <v-tooltip location="right" :activator="`#entity-${thingSchema.id}`">
                            <span
                                >Download {{ thingSchema.displayName }} Custom Entity Setup
                                Excel</span
                            >
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-list-item>
        </v-list>
    </v-menu>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        title: {
            type: String,
            required: true,
        },
        thingSchemas: {
            type: Array,
            required: true,
        },
    },
    methods: {
        selectThingSchema(thingSchema) {
            this.$emit("thingSchemaSelected", thingSchema);
        },
        downloadCustomEntitySetupExcel(thingSchema) {
            this.$emit("downloadCustomEntitySetupExcel", thingSchema);
        },
    },
});
</script>
